import React, {useState, useEffect, useContext} from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";
import calc from "../../../utils/calculation";


import PrintHeader from "../common/PrintHeader";

import Img from "../../common/Img";

import Chart from "./_Chart";
import SummaryCard from "./_SummaryCard";
import PaymentsList from "./_PaymentsList";
import PayableList from "./_PayableList";
import { formatPrintMoney } from "../financePrintUtils";

const StaffSalaryReport = (props) => {

    const {staff_id, activeYear} = props.match.params;


    const [data, setData] = useState([]);
    const [chartData, setChartData] = useState({});
    const [halfYearName, setHalfYearName] = useState("");
    const [payables, setPayables] = useState([]);
    const [payments, setPayments] = useState([]);


    let printHeadTexts = [
        'معاونیت امور اداری و مالی',
        'مدیریت مالی'
    ];

    let title = 'گزارشات';

    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);


    const requestData = async () => {
        let query = `staff/${staff_id}/payments`;

        await db.getAll(query).then(({ data }) => {
            setData(data);
            if(data.data){
                getPayments(data)
                getPayables(data)
                getHalfYearName(data)
            }
        });
    };

    const getPayments = (data) => {
        const filteredData = data?.data[0]?.payments.filter((p) => p.half_year_id == activeYear);
        setPayments(filteredData);
    }


    const getPayables = (data) => {
        const filteredData = data?.data[0]?.payables.filter((p) => p.half_year_id == activeYear);

        const totalChartData = {
            present_count: calc.getTotal(filteredData, "present_count", false),
            absent_count: calc.getTotal(filteredData, "absent_count", false),
            holiday_count: calc.getTotal(filteredData, "holiday_count", false),
        }

        setChartData(totalChartData)
        setPayables(filteredData);
    }

    const getHalfYearName = (data) => {
        for (let row of data?.data[0]?.payments) {
            if (row.half_year_id == activeYear) {
                setHalfYearName(row.half_year)
                break;
            }
        }
    }

    return (
        <main className="main-print-wrapper staff-salary-report-print">
            <PrintHeader
                title={title}
                subtitle={halfYearName}
                date={' '}
                printHeadTexts={printHeadTexts}
            />

            <div style={{display: "grid", gap: "10px"}}>
                <div className="print-finance-top-row" style={{display: "grid", gridTemplateColumns: "auto 70%", gap: "10px"}}>

                    <div className="white-background-with-border">
                        <Chart data={chartData && chartData}/>
                    </div>
                    <div className="white-background-with-border print-finance-profile-panel"
                         style={{
                             display: "grid",
                             gridTemplateColumns: "auto 60%",
                             alignItems: "center",
                             justifyItems: "center",
                             padding: "20px 0"
                         }}>
                        <div className="overall-summary">
                            <div className="wrapper">
                                <p>{lbl.OverallBalance}</p>
                                <h2 className="print-ltr-amount">{formatPrintMoney(data?.summary?.overall_balance)}</h2>
                            </div>
                        </div>
                        <div className="print-finance-profile-row" style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            gap: "20px",
                            alignContent: "flex-end",
                            placeItems: "center",
                            width: "100%",
                            paddingRight: "50px",
                        }}>
                            <div className="std-profile rounded">
                                <div className="wrapper">
                                    <Img src={data?.summary?.staff_photo}/>
                                </div>
                            </div>

                            <div>
                                <div className="wrapper" style={{textAlign: "right"}}>
                                    <h3>{data?.summary?.staff_name}</h3>
                                    <p>{data?.summary?.staff_position}</p>
                                    <p>{data?.summary?.staff_phone}</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="report-summary-area white-background-with-border">
                    <SummaryCard title={lbl.Summary} data={data} payables={payables} payments={payments}/>
                </div>
            </div>

            <p style={{color: "var(--blue)", textAlign: "center"}}>{lbl.Payables}</p>
            <PayableList data={payables}/>

            <p style={{color: "var(--blue)", textAlign: "center"}}>{lbl.Payments}</p>
            <PaymentsList data={payments}/>

            <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء تایید کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء پرداخت کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء گیرنده</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default StaffSalaryReport;
